import { Round } from './Round.js';

// The 'height' parameter is expected to be height in inches (as a decimal)
export function FormatHeight(height, format, precision) {
  let sign = height < 0 ? '-' : '';
  if (height == null || format == null) {
    return null;
  }
  height = Math.abs(height);
  if (typeof HEIGHT_FORMAT_OVRERIDE != 'undefined') {
    format = HEIGHT_FORMAT_OVRERIDE;
  }
  if (format == 'feet-inches') {
    const inches = Math.round(Math.abs(height));
    return sign + Math.floor(inches / 12) + "'-" + (inches % 12) + '"';
  } else if (format == 'feet-inches-long') {
    const inches = Math.round(Math.abs(height));
    return sign + Math.floor(inches / 12) + "'-" + (inches % 12).toLocaleString('en-US', { minimumIntegerDigits: 2 }) + '"';
  } else if (format == 'decimal-feet-inches') {
    return sign + Math.floor(height / 12) + "'-" + Round(height % 12, typeof precision === 'undefined' ? 2 : precision) + '"';
  } else if (format == 'decimal-feet') {
    return sign + Round(height / 12, typeof precision === 'undefined' ? 2 : precision) + "'";
  } else if (format == 'decimal-feet-from-rounded-inches') {
    const inches = Math.round(Math.abs(height));
    return sign + (Math.round(inches) / 12).toFixed(typeof precision === 'undefined' ? 2 : precision) + "'";
  } else if (format == 'decimal-feet-inches-with-precise-inches') {
    const heightInDecimalFeet = Round(height / 12, typeof precision === 'undefined' ? 2 : precision);
    return sign + (Math.round(heightInDecimalFeet * 12) / 12).toFixed(2) + "'";
  } else if (format == 'inches') {
    return sign + Round(height) + '"';
  } else if (format == 'meters') {
    return sign + Round(height * 0.0254, typeof precision === 'undefined' ? 1 : precision) + 'm';
  } else if (format == 'centimeters') {
    return sign + Round(height * 2.54, typeof precision === 'undefined' ? 1 : precision) + 'cm';
  } else if (format == 'millimeters') {
    return sign + Round(height * 25.4, typeof precision === 'undefined' ? 1 : precision) + 'mm';
  } else {
    //decimal-inches
    return sign + height + '"';
  }
}

export function ParseHeight(height) {
  var negative = height.startsWith('-');
  var ftInches = negative ? height.substring(1).split('-') : height.split('-');
  if (ftInches.length == 2 && ftInches[0] != '' && ftInches[1] != '') {
    var ft = parseFloat(ftInches[0]);
    var inches = parseFloat(ftInches[1]);
    return {
      decimalFeet: negative ? -(ft + inches / 12) : ft + inches / 12,
      displayUnit: 'ftIn',
      originalValue: { feet: ft, inches: inches }
    };
  } else {
    var ftInches = height.split('ft');
    if (ftInches.length == 2 && !isNaN(parseFloat(ftInches[0])) && !isNaN(parseFloat(ftInches[1]))) {
      var ft = parseFloat(ftInches[0]);
      var inches = parseFloat(ftInches[1]);
      return {
        decimalFeet: negative ? -(ft + inches / 12) : ft + inches / 12,
        displayUnit: 'ftIn',
        originalValue: { feet: ft, inches: inches }
      };
    } else {
      var ftInches = height.split("'");
      if (ftInches.length == 2 && !isNaN(parseFloat(ftInches[0])) && !isNaN(parseFloat(ftInches[1]))) {
        var ft = parseFloat(ftInches[0]);
        var inches = parseFloat(ftInches[1]);
        return {
          decimalFeet: negative ? -(ft + inches / 12) : ft + inches / 12,
          displayUnit: 'ftIn',
          originalValue: { feet: ft, inches: inches }
        };
      } else if (height.search('mm') != -1) {
        var val = parseFloat(height);
        return { decimalFeet: val / 304.8, displayUnit: 'mm', originalValue: val };
      } else if (height.search('cm') != -1) {
        var val = parseFloat(height);
        return { decimalFeet: val / 30.48, displayUnit: 'cm', originalValue: val };
      } else if (height.search('m') != -1) {
        var val = parseFloat(height);
        return { decimalFeet: val / 0.3048, displayUnit: 'm', originalValue: val };
      } else if (height.search('in') != -1) {
        var val = parseFloat(height);
        return { decimalFeet: val / 12, displayUnit: 'in', originalValue: val };
      } else if (height.search('"') != -1) {
        var val = parseFloat(height);
        return { decimalFeet: val / 12, displayUnit: 'in', originalValue: val };
      } else {
        var val = parseFloat(height);
        return { decimalFeet: val, displayUnit: 'ft', originalValue: val };
      }
    }
  }
}
